import { useState } from 'react';
import './change-password.css';
import FormModal from '../FormModal';
import PasswordInput from '../PasswordInput';
import { logout, put } from '../../services/api';
import { THEME_STORAGE_KEY } from '../../constants/theme';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';

function ChangePassword({ showModal, onClose = () => {} }) {
    const { setMessage, setLoading } = useUI();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);

    function onCloseChangePassword() {
        setCurrentPassword('');
        setNewPassword('');
        setPasswordConfirm('');
        setSubmitAttempt(false);

        onClose();
    }

    function isCurrentPasswordValid() {
        return !!currentPassword && currentPassword.length >= 8;
    }

    function isNewPasswordValid() {
        return !!newPassword && newPassword.length >= 8;
    }

    function isConfirmPasswordValid() {
        return passwordConfirm === newPassword;
    }

    async function onClickChangePass(e) {

        function isChangePassValid() {
            setSubmitAttempt(true);

            return isCurrentPasswordValid() && isNewPasswordValid() && isConfirmPasswordValid();
        }

        e.preventDefault();

        if (!isChangePassValid())
            return;

        setLoading(true);

        const data = {
            currentPassword,
            newPassword,
            passwordConfirm
        };

        await put('user/update-password', data, true, setMessage,
            () => {
                setMessage({ type: 'success', text: 'A sua palavra-chave foi alterada. Você será redirecionado para a tela de login novamente.' });
                setTimeout(() => {
                    localStorage.removeItem(THEME_STORAGE_KEY);
                    logout();
                }, 800);
            },
            (err) => {
                handleErr(setMessage, `Não foi possível alterar a senha do usuário: ${err}`);
            },
            () => {
                setLoading(false);
            }
        )
    }

    if (!showModal)
        return null;

    return (
        <FormModal
            showModal={showModal}
            onClose={onCloseChangePassword}>
            <form className='change-pass-form' autoComplete='off'>
                <PasswordInput
                    id='current-password'
                    name='current-password'
                    className='glass-effect-15'
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    onValidate={isCurrentPasswordValid}
                    maxLength={40}
                    warningMsg='Informe a sua atual palavra-chave.'
                    placeholder='Sua palavra-passe'
                    autoComplete='new-password'
                    shouldValidate={submitAttempt}
                />

                <PasswordInput
                    id='new-password'
                    name='new-password'
                    className='glass-effect-15'
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onValidate={isNewPasswordValid}
                    maxLength={40}
                    warningMsg='Informe a sua nova palavra-chave.'
                    placeholder='Sua nova palavra-passe'
                    autoComplete='new-password'
                    shouldValidate={submitAttempt}
                />

                <PasswordInput
                    id='confirm-new-password'
                    name='confirm-new-password'
                    className='glass-effect-15'
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    onValidate={isConfirmPasswordValid}
                    maxLength={40}
                    warningMsg='Confirme a sua nova palavra-chave. Ela deve ser idêntica a digitada acima.'
                    placeholder='Confirme a palavra-passe'
                    autoComplete='new-password'
                    shouldValidate={submitAttempt}
                />

                <section className="change-pass-buttons">
                    <input
                        type='submit'
                        id='save-user-perfil'
                        className='user-form-button blue-button zoom-effect'
                        value="Salvar"
                        onClick={onClickChangePass}
                    />
                </section>
            </form>
        </FormModal>
    );
}

export default ChangePassword;